module.exports = __webpack_public_path__ + "img/c02_unitpriestofptah_Normal_ua.f3d10384.webp";